module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_5010.e9a9d526.png";